import React, { useState, useEffect } from "react";
import "./index.css";

function UpdateModal({ show, onClose, onUpdate, fieldData }) {
  // Initialize state with existing field data.
  const [fieldType, setFieldType] = useState("");
  const [label, setLabel] = useState("");
  const [required, setRequired] = useState(false);
  const [options, setOptions] = useState([]);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");

  // When fieldData changes, initialize local state
  useEffect(() => {
    if (fieldData) {
      setFieldType(fieldData.fieldType || "");
      setLabel(fieldData.label || "");
      setRequired(fieldData.required || false);
      setOptions(fieldData.options || []);
      setImageUrl(fieldData.image || "");
    }
  }, [fieldData]);

  if (!show) return null;

  const addOption = () => setOptions([...options, ""]);
  const removeOption = (index) => setOptions(options.filter((_, i) => i !== index));
  const handleOptionChange = (index, value) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    setImage(file);

    const formData = new FormData();
    formData.append("image", file);

    const res = await fetch("https://leadbankapi.gensparc.com/api/upload", {
      method: "POST",
      body: formData,
    });

    const data = await res.json();
    setImageUrl(data.imageUrl);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create an updated field object (you can include id from fieldData if needed)
    const updatedField = {
      ...fieldData,
      fieldType,
      label,
      required,
      options: fieldType === "dropdown" ? options : [],
      image: fieldType === "image" ? imageUrl : "",
    };

    // Call onUpdate callback to trigger the API call from the parent component
    await onUpdate(updatedField);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Update Custom Field</h2>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Field Type:</label>
              <select
                value={fieldType}
                onChange={(e) => setFieldType(e.target.value)}
                required
              >
                <option value="">Select Field Type</option>
                <option value="text">Text</option>
                <option value="number">Number</option>
                <option value="dropdown">Dropdown</option>
              </select>
            </div>

            <div className="form-group">
              <label>Label:</label>
              <input
                type="text"
                placeholder="Enter Label"
                value={label}
                onChange={(e) => setLabel(e.target.value)}
                required
              />
            </div>

            <div className="">
              <input
                type="checkbox"
                id="requiredUpdate"
                checked={required}
                onChange={(e) => setRequired(e.target.checked)}
              />
              <label htmlFor="requiredUpdate">Required</label>
            </div>

            {fieldType === "dropdown" && (
              <div className="dropdown-options-section">
                <label className="options-label">Option List:</label>
                {options.map((opt, index) => (
                  <div key={index} className="option-row">
                    <input
                      type="text"
                      placeholder="Option"
                      value={opt}
                      onChange={(e) => handleOptionChange(index, e.target.value)}
                    />
                    <button
                      type="button"
                      className="remove-option-btn"
                      onClick={() => removeOption(index)}
                    >
                      &times;
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn add-another-btn"
                  onClick={addOption}
                >
                  + Add Another
                </button>
              </div>
            )}

            {fieldType === "image" && (
              <div className="form-group">
                <label>Upload Image:</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                />
                {imageUrl && (
                  <img
                    src={`https://leadbankapi.gensparc.com${imageUrl}`}
                    alt="Uploaded Preview"
                    className="uploaded-preview"
                  />
                )}
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn submit">
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdateModal;
